import request from "../libs/request";

import {
  EmergencyBleType,
  EmergencyGpsType,
  EmergencyNfcType,
  EmergencyQrJsonCode,
  EmergencySituationType,
  EmergencyStatusType,
} from "../types/emergency";
import { PushItem } from "../types/member";

import { PageableRequest, PageableResponse } from "./talkServices";

const baseUrl = "evacuation/situation";
const managerUrl = `${process.env.REACT_APP_API_URL}/v2/manager/evacuation/situation`;

// 회원 대피상황 기본 조회 - 상황 ID 없이
export const getSituation = () =>
  request.get<EmergencySituationType>(baseUrl + `/home`);

// 회원 대피상황 기본 조회 - 상황 ID 포함
export const getSituationById = (situationId: string) =>
  request.get<EmergencySituationType>(baseUrl + `/home/${situationId}`);

// 회원 휴가/구조요청 상태 변경
export const patchStatus = (
  situationId: string,
  params: EmergencyStatusType,
  isManagerSelf: boolean = false
) =>
  request.patch(
    isManagerSelf
      ? managerUrl + `/status/${situationId}`
      : baseUrl + `/status/${situationId}`,
    params
  );
// 회원 QR 대피 완료처리
export const patchQr = (situationId: string, params: EmergencyQrJsonCode) =>
  request.patch(baseUrl + `/qr/${situationId}`, params);
// 회원 NFC 대피 완료처리
export const patchNfc = (situationId: string, params: EmergencyNfcType) =>
  request.patch(baseUrl + `/nfc/${situationId}`, params);
// 회원 GPS 대피 완료처리
export const patchGps = (situationId: string, params: EmergencyGpsType) =>
  request.patch(baseUrl + `/gps/${situationId}`, params);

// 회원 블루투스(BLE) 대피 완료처리
export const patchBle = (situationId: string, params: EmergencyBleType) =>
  request.patch(baseUrl + `/ble/${situationId}`, params);

export const getEvacuationPushList = (
  params: Partial<PageableRequest>,
  situationId: string
) =>
  request.get<PageableResponse<PushItem>>(
    baseUrl + `/${situationId}` + "/push/list",
    { params }
  );

// 비회원
const unCertBaseUrl = baseUrl + "/uncert";

// 비회원 대피상황 기본 조회 - 상황 ID 대신 Mapping된 uuid 사용
export const getUncertSituation = (evacuationEvacueeMapUuid: string) =>
  request.get<EmergencySituationType>(
    unCertBaseUrl + `/home/${evacuationEvacueeMapUuid}`
  );
// 비회원 휴가/구조요청 상태 변경
export const patchUncertStatus = (
  evacuationEvacueeMapUuid: string,
  params: EmergencyStatusType
) =>
  request.patch(unCertBaseUrl + `/status/${evacuationEvacueeMapUuid}`, params);
// 비회원 QR 대피 완료처리
export const patchUncertQr = (
  evacuationEvacueeMapUuid: string,
  params: EmergencyQrJsonCode
) => request.patch(unCertBaseUrl + `/qr/${evacuationEvacueeMapUuid}`, params);
// 비회원 GPS 대피 완료 처리
export const patchUncertGps = (
  evacuationEvacueeMapUuid: string,
  params: EmergencyGpsType
) => request.patch(unCertBaseUrl + `/gps/${evacuationEvacueeMapUuid}`, params);
